import { render, staticRenderFns } from "./TruncatedAlert.vue?vue&type=template&id=d32ed0d0"
import script from "./TruncatedAlert.vue?vue&type=script&lang=js"
export * from "./TruncatedAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports